// extracted by mini-css-extract-plugin
export var chevron = "locale-selection-module--chevron--d1a85";
export var chevronOpen = "locale-selection-module--chevronOpen--f07dd";
export var container = "locale-selection-module--container--25dc4";
export var focusedOption = "locale-selection-module--focusedOption--ee341";
export var menu = "locale-selection-module--menu--1cdf7";
export var menuOpen = "locale-selection-module--menuOpen--1100a";
export var menuOption = "locale-selection-module--menuOption--b1cee";
export var target = "locale-selection-module--target--a3e3a";